import _ from "lodash";

const calculVetusteMAE = (nbMois, valeurAchat) => {
    if (nbMois === 0) {
        return {
            valeurRemboursement: '0.00',
            montantVetuste: '0.00',
            explication: '0 mois = aucune vétusté',
            palier: '0 mois',
            niveau_vetuste: 0,
            nbMois: 0
        };
    }

    const tauxVetustePourcent = nbMois >= 36 ? 60 : Math.round(nbMois * (20 / 12) * 100) / 100;
    const montantVetuste = Math.round(valeurAchat * tauxVetustePourcent) / 100;

    return {
        valeurRemboursement: (valeurAchat - montantVetuste).toFixed(2),
        montantVetuste: montantVetuste.toFixed(2),
        explication: tauxVetustePourcent.toFixed(2) + '% de vétusté',
        palier: nbMois >= 36 ? '>= 36 mois' : nbMois + ' mois',
        niveau_vetuste: tauxVetustePourcent,
        nbMois: nbMois
    };
};

const vetuste = (dateSurv, dateAchat, valeurAchat, isMAE = false) => {
    if (dateAchat.isAfter(dateSurv)) {
        throw new Error('Date de survenance avant la date d\'achat. Merci de réaffecter au niveau 2');
    }

    const nbMois = Math.floor(dateSurv.diff(dateAchat, 'months', true));

    if (isMAE) {
        return calculVetusteMAE(nbMois, valeurAchat);
    }

    const paliers = {
        12: 0.14,
        14: 0.25,
        24: 0.407296,
        48: 0.50212864,
        60: 0.581788058,
        72: 0.648701968,
        84: 0.704909653,
        96: 0.752124109,
        108: 0.791784251,
        120: 0.825098771,
        132: 0.853082968,
        144: 0.876589693,
        156: 0.896335342,
        999: 0.9
    };

    const keys = _.keys(paliers);

    let item = _.find(keys, function (k) {
        return Number(k) >= nbMois;
    });

    let key;
    let index;

    if (item === undefined) {
        key = _.last(keys);
    } else {
        index = _.indexOf(keys, item);
        if (index === 0) {
            key = keys[index];
        } else {
            key = keys[index - 1];
        }
    }

    let palier;
    if (key < 12) {
        palier = '< ' + key + ' mois';
    } else if (key === "999") {
        palier = '> ' + (_.findLast(keys, function (k) {
            return k !== "999";
        }) / 12) + ' ans';
    } else if (key === "12") {
        palier = '< 1 an';
    } else {
        palier = '> ' + Math.round(key / 12) + ' ans';
    }

    return {
        valeurRemboursement: (valeurAchat * (1 - paliers[key])).toFixed(2),
        explication: Math.round(paliers[key] * 100) + '% de décôte',
        palier: palier,
        niveau_vetuste: Math.round(paliers[key] * 100)
    };
};

export default vetuste;